import { AddClientRequestInput } from "generated/graphql";
import React, { useState } from "react";
import { AddressCreationInput } from "../generated/graphql";

export const defaultAddress: AddressCreationInput = {
  address: "",
  place_id: "",
};

const defaultCompany: AddClientRequestInput = {
  client_company_name: "",
  client_activity: "",
  client_address: defaultAddress,
  client_contact_firstname: "",
  client_contact_lastname: "",
  client_contact_job: "",
  client_contact_email: "",
  client_contact_phone_number: "",
  client_phone_number: "",
};
export interface RegisterProviderState {
  client: typeof defaultCompany;
  setClient: (company: typeof defaultCompany) => void;
}
export const RegistrationContext = React.createContext<RegisterProviderState>(null);

export const useRegistrationContext = () => React.useContext(RegistrationContext);

export const RegistrationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [client, setClient] = useState<AddClientRequestInput>(defaultCompany);

  return (
    <RegistrationContext.Provider
      value={{
        client,
        setClient,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};

